<!--
 * @Author: Merlin
 * @Date: 2024-01-12 14:35:54
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 16:49:30
 * @Description: 
-->
<template>
    <NuxtLayout name="game-coat"
        :topHeight="'500px'"
    >
        <template #bgImg>
            <img src="./img/pharaoh-bg.webp" />
        </template>
        <template #panel-left>
            <CasinoBetOptionSection
                class="control-bar"
                v-model:bet-amount-modal-value="oForm.amount"
                v-model:is-submiting="bLockLeftPanel"
                :isAuto="isAutoMode"
                @change-mode="toChangeMode"
            >
                <template #bet-button>
                    <ButtonThe2RowsButton
                        narrow
                        class="h-full"
                        size="lg"
                        full-width
                        @click="clickOnBetButton01"
                        :disabled="disRedButton"
                        :dismark="disRedButton"
                        v-click-and-rest
                    >
                        {{ sRedButtonText }}
                        <template #secondRow v-if="isAutoMode">
                            <span class="inline-block mt-1">
                                {{ autoOption.sRoundsRest }}
                            </span>
                        </template>
                    </ButtonThe2RowsButton>
                </template>
            </CasinoBetOptionSection>
            <!-- ↓ 购买大奖  -->
            <ButtonThe3DButton
                class="mt-3"
                color="blue"
                size="lg"
                fullWidth
                v-click-and-rest
                v-if="!isAutoMode"
                :disabled="disBlueButton"
                :dismark="disBlueButton"
                @click="clickBlueButton"
            >
                <template #default>
                    {{ $t('pharaoh.BuyBonus').toUpperCase() }}
                </template>
                <template #secondRow>
                    <ClientOnly>
                        {{ bonousPrice }}&nbsp;{{oUserStore.oNowCurrency.currencyName.toUpperCase()}}
                    </ClientOnly>
                </template>
            </ButtonThe3DButton>
            <!-- ↓ 半透明渐变遮罩，Mini 版新增  -->
            <div class="bottom-mas"></div>
        </template>
        <!--
            左右
            大分界
        -->
        <template #playing-area-right>
            <div class="game-layout__game-inner"
                :style="{
                    height: `${iStageHeight}px`,
                    width: `100%`,
                    'margin-top': '-25px',
                }"
            >
                <!-- ↓ 自制的资源预加载，用于 canvas --> 
                <picture
                    class="absolute opacity-[0.1] w-[1px] h-[1px]"
                >
                    <source type="image/avif" srcset="./img/atlas.avif" />
                    <img ref="oBigPic" src="./img/atlas.png" />
                </picture>
                <div class="game-wrapper"
                    wide="false"
                    available-chips="1,10,100"
                    :style="{transform: `scale(${animation ? scale : 1})`, transition: 'transform 1s'}"
                >
                    <!-- ↓ 显示赢钱金额（默认隐藏，赢了一次再显示出来） -->
                    <!-- ↓ Mini 版没有空间放这个 -->
                    <!-- <div class="lasw-win-wrp"
                        v-if="iAmountLastWin > 0"
                    >
                        <span class="currency" style="cursor: pointer">
                            <CurrentCoin class="currency__icon" size="16px" ></CurrentCoin>
                            <span style="font-size: 16px" >
                                <span style="color: #fff" class="font-digits">
                                    {{iAmountLastWin.beFixed(2)}}
                                </span>
                            </span>
                        </span>
                    </div> -->
                    <!-- ↑ 显示赢钱金额（默认隐藏）-->
                    <!-- ↓ 舞台大背景，重点图 -->
                    <img class="bpaharaon-bg" src="./img/bg_mob.webp" />
                    <canvas
                        width="2088"
                        height="1149"
                        class="slotCanvas"
                        ref="slotCanvas"
                    ></canvas>
                    <!--
                        ======== ↓ 以下是弹出内容 ====================================
                    -->
                    <article class="bonusgame-wrp">
                        <!-- ↓ 购买特奖的窗口 -->
                        <section class="buy-bonus-win"
                            v-if="sCenterDialog=== 'buying'"
                        >
                            <img class="buy-bonus-win-bg" src="./img/buybonusgamebg.png" />
                            <p>
                                <span class="currency">
                                    <CurrentCoin class="currency__icon" size="24px" />
                                    <span style="font-size: 24px" >
                                        <span style="color: #fff" class="font-digits" >
                                            <!-- {{111}}<span style="color: #fff">.{{111}}</span> -->
                                            {{ bonousPrice }}
                                            <!-- ↑购买特奖的费用，标价 -->
                                        </span>
                                    </span>
                                </span>
                            </p>
                            <!-- ↓下方的按钮 -->
                            <div class="buy-bonus-win-btns">
                                <img src="./img/btn_cencel.png"
                                    @click="closeCenterDialog"
                                />
                                <img src="./img/btn_buy.png"
                                    @click="toBuy"
                                />
                            </div>
                        </section>
                        <!-- ↓ 购买后摇奖窗口 -->
                        <section class="bonus-game-win"
                            v-if="sCenterDialog === 'rolling'"
                        >
                            <img class="bonus-game-win-bg" src="./img/bonusgamebg.png" />
                            <div class="clickSpin_wrp" v-if="!rollingStarted">
                                <img class="clickSpin"
                                    src="./img/clickSpin.webp"
                                    @click="onBonusGame"
                                />
                            </div>
                            <div class="canvasBonus">
                                <img class="fireFrame"
                                    src="./img/fireFrame.png"
                                    :style="{transform: `scale(${scaleFire})` }"
                                />
                                <!-- ↓ 摇奖（特奖）画布 -->
                                <canvas width="832" height="418"
                                    ref="canvasBonus"
                                    :style="{transform: `scale(${animation ? scaleBonus : 1})` }"
                                >
                                </canvas>
                            </div>
                        </section>
                        <!-- ↓ 摇特奖结束后显示摇奖结果（赢） -->
                        <section class="bonusGameWinData"
                            v-if="sCenterDialog === 'rollingResult-win'"
                        >
                            <img src="./img/bonusWin.png" />
                            <p>
                                <span class="currency" >
                                    <CurrentCoin class="currency__icon" size="20px" />
                                    <span style="font-size: 24px" >
                                        <span style="color: #fff" class="font-digits" >
                                            <!-- {{111}}<span style="color: #fff">.{{111}}</span> -->
                                            {{iAmount4Show}}
                                        </span>
                                    </span>
                                </span>
                            </p>
                        </section>
                        <!-- ↓ 摇特奖结束后显示摇奖结果（输了） -->
                        <section class="buy-bonus-win"
                            v-if="sCenterDialog === 'rollingResult-lose'"
                        >
                            <img class="buy-bonus-win-bg-zero" src="./img/bonusGameWinZero.png" />
                            <!-- ↓提供关闭按钮引发的麻烦不少 -->
                            <img class="green_close"
                                src="./img/green_close.png"
                                @click="endShowBonusGame"
                            />
                        </section>
                    </article>
                    <!-- ↓图 -->
                    <img v-if="sCenterDialog"
                        class="book-bg"
                        src="./img/book.webp" 
                    />
                    <!-- ↑ 弹出窗口 -->
                    <!-- <img id="currentCurrencyPharaoh"
                        class="currency__icon"
                        width="24"
                        height="24"
                        src="/images/coin/x.svg"
                        loading="lazy"
                    /> -->
                </div>
            </div>
        </template>
    </NuxtLayout>
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        :is-fast="false"
        :is-submiting="oForm.isSubmiting"
        :is-auto="isAutoMode"
        v-model:amount="oForm.amount"
        :ref="el => oAutoDialog=el"
        :gameName="'kenoGame'" 
    />
</template>

<!--  -->
<script lang="ts">
import { useBettingToolkit } from '@/common/js/bettingToolkit/index';
import type { FormObject } from '@/common/js/bettingToolkit/index';
import {oMethods, aHeightArr} from './js/pharaoh-methods.js';
// 
import useSettingsStore from '@/stores/settings/index';
import useGlobalStore from '@/stores/global';
import {useUserStore} from '@/stores/user';
import {useJoinStateStore} from '@/stores/cansino/joinState';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
// 
import {useAutoBetToolKit} from '@/common/js/bettingToolkit/auto';

export default {
    name: 'pharaohGame',
    data(){
        const oForm:FormObject = {
            amount: 0,
            isSubmiting: false, // 状态为 false 则停止自动下注
        };
        // ↓ 外来数据 
        const oDataBorrowed = {
            canvasSizeIndex: 0, 
            scaleBonus: 1, // 用于摇奖窗口动画
            scaleFire: .1, // 用于摇奖窗口动画
            scale: 1, // 大画布缩放 
        };
        // ↓ 界面控制相关 
        const oInterface = {
            sCenterDialog: '',
            // ↓ 点击摇奖时将此设为 true，即在摇奖之后立即隐藏摇奖按钮  
            rollingStarted: false, // 小画布的 rolling 状态都在此标记 
            rollingOnBigCanvas: false, // 
            iStageHeight: aHeightArr[1], 
            iAmountLastWin: 0, // 上次赢钱金额，每次赢钱后更新此值 
            iClosePlan: 0, // 关闭中部弹窗的定时器，保存在这里
            oAutoDialog: null,
        };
        const oStores = {
            oGlobal: useGlobalStore(),
            oUserStore: useUserStore(),
            oSettingsStore: useSettingsStore(),
            oJoinStateStore: useJoinStateStore(),
            autoOption: useAutoOptionStore(),
        };
        // ↓ 保存游戏结果
        const oResult = {
            winAmount: 0,
            // showAmount: false, // 值为真时再显示金额：考虑删除
            roll_number: "067", // N3,N4,N4,N3,N4,H1,B,N4,N4
            bonusWin: false, // ← 普通摇奖时标为 false 
        };
        // ↓ 用于 bonus 摇奖，包含： oPromise, resolve, reject
        const oBonusRolling = { // 用于自动模式
            ...createPromise(), // 预置值，将被正式值覆盖 
            // ↓ 自动模式的某次摇奖如果中了 bonus，那么设此为 true，
            pending: false, 
        }
        return {
            oForm,
            oResult,
            oBonusRolling,
            // ↑ 一些对象 -------------------------
            ...oDataBorrowed,
            ...oInterface,
            ...oStores,
            oMusicControler: null, // 音乐
            isAutoMode: false,
            iJoinMark: 0, // 012 = 未开始，旋转中，已结束 
            g_instance: {},
            m_instance: {},
            hasLoaded: false, // 将被 mounted 设为 true  
            oCanvasInstanceStatus: import.meta.client && createPromise(), // 用于
            sHashLoaded: '', 
        };
    },
    computed: {
        // ↓ 特奖金额
        bonousPrice(){
            const {amount=0} = this.oForm;
            return (amount * 80).beFixed(2);
        },
        // ↓ 🟥 红按钮文字
        sRedButtonText(){
            const {t: $tFn} = useNuxtApp().$i18n;
            if (this.isAutoMode){
                if (this.oForm.isSubmiting) {
                    return $tFn(this.oGlobal.autoModeBtnWords.stop);
                }else{
                    return $tFn(this.oGlobal.autoModeBtnWords.start);
                }
            }else { // ←临时条件
                return $tFn('pharaoh.Bet');
            }
        },
        isFast(){
            const {fast} = this.oSettingsStore.inhouseGames.pharaoh;
            return !!fast;
        },
        animation(){
            const {animation} = this.oSettingsStore.inhouseGames.pharaoh;
            // console.log("computed: animation =", animation);
            return !!animation;
        },
        // ==== 👇 计算禁用信息 ==================================================
        // ↓锁定左侧面板
        bLockLeftPanel: {
            get(){
                const arr01 = [
                    // this.sCenterDialog === 'rolling',
                    !!this.sCenterDialog,
                    this.oForm.isSubmiting,
                    this.disBlueButton,
                ];
                const bResult = arr01.some(Boolean);
                return bResult;
            },
            set(newVal){
                console.log("newVal", newVal);
            },
        },
        // ↓ 🟦 禁用蓝色按钮 
        disBlueButton(){
            const {sCenterDialog, rollingOnBigCanvas} = this;
            const arr = [
                // sCenterDialog == 'buying',
                // sCenterDialog == 'rolling',
                // sCenterDialog.startsWith('rollingResult-'),
                !this.hasLoaded,
                !!sCenterDialog,
                rollingOnBigCanvas,
            ];
            return arr.some(Boolean);
        },
        // ↓ 🟥 禁用红按钮 
        disRedButton(){
            if (!this.hasLoaded){
                return true; // 禁用 
            }
            if (this.isAutoMode){
                return false;
            }
            // ---- ↑自动模式，↓手动模式 --------------------
            const arr = [
                this.rollingOnBigCanvas,
                this.sCenterDialog == 'rolling',
            ];
            return arr.some(Boolean);
        },
        // ==== 👆 计算禁用信息 ==================================================
        // ↓赢钱的金额 
        iAmount4Show(){
            const {winAmount=0} = this.oResult;
            const iTailLong = winAmount < 1 ? 8 : 4;
            return winAmount.beFixed(iTailLong);
        },
    },
    // ===== ↑ 数据 ❤️ ↓ watch ========================================================================
    watch: {
        'oGlobal.innerWidth': {
            handler(iNew){
                if (!this.hasLoaded) return;
                // console.log("watch: oGlobal.innerWidth", ); 
                this.setCanvas();
                this.setDomHeight();
            },
        },
        // ↓ 控制两侧的火球在播放，或停止 
        'oSettingsStore.inhouseGames.pharaoh': {
            deep: true,
            handler(oNew){
                // console.log("oNew.fast", oNew.fast);
                // console.log("oNew.animation", oNew.animation);
                (this.g_instance as any).animation = !!oNew.animation;
                (this.m_instance as any).animation = !!oNew.animation;
            },
        },
        // ↓ 页面刷新后加载未完成的游戏 
        'oJoinStateStore.activeBonusGame': {
            deep: true,
            immediate: true,
            handler(oActive){
                if (!import.meta.client || !oActive?.isBonusGame) return;  
                if (this.sHashLoaded === oActive.hash) return; 
                this.sHashLoaded = oActive.hash;
                const oGamingData = deepCopy(oActive);
                // console.log("oActive?.isBonusGame\n", oActive?.isBonusGame);  
                // console.log("😂 activeBonusGame =", oActive);
                // ↓ 等待组件动画实例创建完成，否则将报错  
                this.oCanvasInstanceStatus.oPromise.then(res=>{
                    this.startShowBonusGame(true);
                });
                showLastRoundLoadedInfo();
                this.oJoinStateStore.gameRunning = true; // 设为“游戏进行中” 
            },
        },
    },
    methods: {
        ...oMethods,
    },
    // == ↓ 最后是生命周期 =======================
    mounted(){
        // ↓ 确保顺序无误 01, 02, 
        this.oMusicControler = this.musicLoader(); // step 01 
        const oPromise01 = this.startTheAnim(); // step 02 ◆ 在此创建动画实例，会用到 step 01 创建的音乐控件 
        // ======================================
        const { stopInfinity, startInfinity, } = useAutoBetToolKit(
            this.oForm,
            this.fnForAutoBetTool,
        );
        Object.assign(this, {
            stopInfinity,
            startInfinity,
        });
        useBettingToolkit(this.oForm); // 设定默认下注金额 
        // ======================================
        oPromise01.then((res) => {
            this.hasLoaded = true;
            this.setDomHeight(); // 之前在 setCanvas() 下方执行，
            this.setCanvas();
        });
    },
    beforeUnmount(){
        (this.g_instance as any).live = false;
        (this.m_instance as any).live = false;
        this.oMusicControler?.toDestory(); 
    },
}

</script>

<style lang="scss" scoped src="./style/pharaoh_index.scss" />
<style lang="scss" scoped src="./style/pharaoh_index-02.scss" />

